import React from 'react';
import styles from './Quiz.module.css';
import { motion } from 'framer-motion';
import classNames from 'classnames';
import { useGetParams } from '../../hooks/useGetParams';

const Quiz = ({ className, variants }) => {
  const { answerFontSize } = useGetParams();
  const correctAnswer = variants.find((el) => el.correct);

  if (!correctAnswer) return null;

  const image = correctAnswer.varImgUrl;
  const name = correctAnswer.comment.trim().split(/\s+/)[0];
  const surname = correctAnswer.comment
    .trim()
    .split(/\s+/)
    .slice(1, 2)
    .join(' ');
  const number = correctAnswer.comment.trim().split(/\s+/).slice(2).join(' ');

  return (
    <motion.div
      key={image + name + surname}
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
      className={classNames(className, styles.container)}
    >
      <div className={styles.imageContainer}>
        <img
          src={image}
          alt=""
          className={classNames(styles.questionImg, {
            [styles.onlyAnswer]: variants.length <= 1,
          })}
        />
      </div>

      <div
        style={{ display: 'flex', alignItems: 'center' }}
        className={styles.answer}
      >
        <div
          className={styles.info}
          style={{ fontSize: `${answerFontSize}rem` }}
        >
          <div className={styles.name}>{name}</div>
          <div className={styles.surname}>{surname}</div>
          <div className={styles.number}>{number}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default React.memo(Quiz);
